export enum EWorldAction {
    SELECT,
    MULTISELECT,
    TEXT,
    TEXT_V2,
    POINT_SELECT,
    DRAW,
    DIRECTION,
    REACT,
    AI_GENERATION,
    LINE_V2,
    POLYGON_V2,
    ICON_V2,
    VARIANT_ICON_V2,
    POLYGON_V2_WALL,
    LINE_V2_WALL,
    IMAGE_V2,
    INDOOR_STAND,
    UPLOAD
}

export interface ISizePosition {
    width: number;
    height: number;
    left: number;
    top: number;
}

export interface IFilesToUpload {
    type: 'image';
    lat?: number;
    lng?: number;
    zoom?: number;
    fileList: FileList;
}

export type InitMapRectangleType = 'desktop' | 'mobile';
